import {
  Box,
  Chip,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import moment from "moment";
import { isSchoolLocation } from "../tools";
import { truncate } from "lodash";

interface RouteLocationListComponentProps {
  selectedData: any;
  busSchedule: any;
  school: any;
}

const useStyles = makeStyles({
  dragContent: {
    padding: "0px 5px",
  },
  studentChipBox: {
    paddingLeft: 10,
  },
  studentChip: {
    margin: 5,
    backgroundColor: "#FFFFFF",
    color: "#6B6B6B",
    border: "1px solid #E3E3E3",
    borderRadius: 5,
  },
  studentChipWrapper: {
    marginBottom: 13,
  },
  arriveInputWrapper: {
    padding: "0px 5px",
  },
});

const RouteLocationListComponent = ({
  selectedData,
  busSchedule,
  school,
}: RouteLocationListComponentProps) => {
  const classes = useStyles();

  const Item = styled("div")({
    marginBottom: "20px",
    border: "1px solid #EAEAEA",
    borderRadius: "10px",
    padding: "18px",
    "&:hover": {
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.08)",
    },
  });

  return (
    <div
      style={{
        marginTop: "30px",
        maxHeight: "800px",
        overflowY: "auto",
      }}
    >
      {selectedData.routeLocations.map((location: any, index: number) => (
        <Item key={`location-${index}`}>
          {isSchoolLocation(
            index,
            selectedData.routeLocations.length,
            busSchedule.type,
          ) ? (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontSize: "13pt",
                    fontWeight: 600,
                    alignSelf: "center",
                  }}
                >
                  {school.name}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={12}>
                <Typography
                  style={{
                    fontSize: "11pt",
                    fontWeight: 500,
                    alignSelf: "center",
                  }}
                >
                  {location.address}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  style={{
                    fontSize: "11pt",
                    fontWeight: 600,
                    alignSelf: "center",
                  }}
                >
                  {location.arrivalTime && (
                    <span>
                      {busSchedule.type === "to_school"
                        ? "Arrival Time"
                        : "Departure Time"}{" "}
                      : {location.arrivalTime}
                    </span>
                  )}
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box display="inline-flex">
                  <Typography
                    style={{
                      fontSize: "10pt",
                      fontWeight: "bold",
                      alignSelf: "center",
                      borderRadius: "50%",
                      width: "25px",
                      height: "25px",
                      marginRight: "13px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: selectedData.routeColor.colorTwo,
                      color: "#FFFFFF",
                    }}
                  >
                    {location.order}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "13pt",
                      fontWeight: 500,
                      alignSelf: "center",
                      maxWidth: "500px",
                    }}
                  >
                    {location.blockNumber} {location.street}{" "}
                    {location.postalCode}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body2">
                  Arrival Time :{" "}
                  {moment(location.arrivedAt, "HH:mm").format("HH:mm")}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body2">
                  Remark Drop/Pick Location : {location.remark ?? "-"}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={12} className={classes.studentChipWrapper}>
                {location.students
                  .sort((a: any, b: any) => a.id - b.id)
                  .map((student: IStudent) => {
                    return (
                      <Chip
                        label={`
                        ${student.locationCode} - 
                        ${truncate(`${student.firstName} ${student.lastName}`, {
                          length: 15,
                        })}`}
                        className={classes.studentChip}
                      />
                    );
                  })}
              </Grid>
            </Grid>
          )}
        </Item>
      ))}
    </div>
  );
};

export default RouteLocationListComponent;
